import {Record} from 'immutable';
import {schema} from 'normalizr';
import {ParticipantSchema} from './Participant';
import {ThreadFileSchema} from './ThreadFile';
import {WorkflowStatusSchema} from './WorkflowStatus';

const ThreadEvent = Record({
    id: null,
    createdAt: null,
    author: null,
    type: null,
    body: null,
    owner: null,
    workflowStatus: null,
    threadFile: null,
    isAutomaticReply: null,
});

export const ThreadEventSchema = new schema.Entity('threadEvents', {
    author: ParticipantSchema,
    owner: ParticipantSchema,
    workflowStatus: WorkflowStatusSchema,
    threadFile: ThreadFileSchema
});

export default ThreadEvent;
